import React from "react";
import "./Download_free.css";
import { Link } from "react-router-dom";

function Download_free() {
  return (
    <>
      <section className="download_free section_margin">
        <div className="container">
          <div className="desktop_view_holder">
            <div className="mochups_transition_section">
              <div className="transition_holder">
                <div className="img_holder left_img_3 sub_img_3">
                  <img
                    src="/assets/images/home/download_free/img_2.png"
                    alt="mock_1"
                    className="mock_up"
                  />
                </div>

                <div className="img_holder left_img_2 sub_img_2">
                  <img
                    src="/assets/images/home/download_free/img_2.png"
                    alt="mock_1"
                    className="mock_up"
                  />
                </div>

                <div className="img_holder left_img_1 sub_img_1">
                  <img
                    src="/assets/images/home/download_free/img_2.png"
                    alt="mock_1"
                    className="mock_up"
                  />
                </div>

                <div className="img_holder main_img">
                  <img
                    src="/assets/images/home/download_free/img_1.png"
                    alt="mock_1"
                    className="mock_up"
                  />
                </div>

                <div className="img_holder right_img_1 sub_img_1">
                  <img
                    src="/assets/images/home/download_free/img_2.png"
                    alt="mock_1"
                    className="mock_up"
                  />
                </div>

                <div className="img_holder right_img_2 sub_img_2">
                  <img
                    src="/assets/images/home/download_free/img_2.png"
                    alt="mock_1"
                    className="mock_up"
                  />
                </div>

                <div className="img_holder right_img_3 sub_img_3">
                  <img
                    src="/assets/images/home/download_free/img_2.png"
                    alt="mock_1"
                    className="mock_up"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mobile_view_holder">
            <div className="img_holder">
              <img
                src="/assets/images/home/download_free/full_img_mockup.png"
                alt=" mockup img"
                className="mockup_img"
              />
            </div>
          </div>

          <div className="text_holder">
            <h5>DOWNLOAD FREE ON</h5>
            <div className="play_store_img_holder">
              <Link
                to={
                  "https://play.google.com/store/apps/details?id=com.my_mds&pcampaignid=web_share"
                }
                target="_blank"
              >
                <div className="img_holder">
                  <img
                    src="/assets/images/play_store/google_play.png"
                    alt="google play"
                    className="play_store"
                  />
                </div>
              </Link>
              <Link
                to={"https://apps.apple.com/us/app/my-mds/id6761702700"}
                target="_blank"
              >
                <div className="img_holder">
                  <img
                    src="/assets/images/play_store/app_store.png"
                    alt="play store"
                    className="play_store"
                  />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Download_free;
